<div echarts [options]="options" class="chart-container" (chartInit)="onChartInit($event)"></div>